import React, { Component } from 'react';
import { Input } from 'react-bootstrap';
import 'react-select/dist/react-select.css';

export class PriceField extends Component {
  render() {
    const { input } = this.props;
    return (
      <Input {...input} standalone type="text" addonBefore="$" addonAfter=".0000"/>
    )
  }
}

export class DisabledPriceField extends Component {
  render() {
    const { input } = this.props;
    return (
      <Input {...input} standalone type="text" disabled value={this.props.V} addonBefore="$" addonAfter=".0000" onChange={input.onChange(this.props.V)}/>
    )
  }
}

export default PriceField;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/priceField.jsx